import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useDispatch } from "react-redux";
import { coinNetworks } from "../../../actions/coinNetworks";
import { userCoinBalance } from "../../../actions/user";
//Icon
import styles from "./ExternalTransfer.module.scss";
import WaningIcon from "../../../styles/icon/warning.svg";
import ArrowIcon from "../../../styles/icon/arrow_wallet.svg";
import { useSelector } from "react-redux";
import ErrorBox from "../../../helpers/errors_notifications/ErrorBox";
import { withdrawCoins } from "../../../services/adminServices";
import { errorMessage, successMessage } from "../../../utils/messages";

export function Enter2FACode({
  withdrawCoinDetails,
  setWithdrawCoinDetails,
  name,
}) {
  //Change name as asset
  const dispatch = useDispatch();
  const handleSubmitWithdraw = async (e) => {
    e.preventDefault();
    const re = /^[0-9\b]+$/;
    if (!withdrawCoinDetails.twoFacCode) return;
    if (withdrawCoinDetails.twoFacCode.length < 6) return;
    if (!re.test(withdrawCoinDetails.twoFacCode)) return;
    const { walletAddress, walletTag, withdrawalAmount, chain, twoFacCode } =
      withdrawCoinDetails;
    const withdrawInfo = {
      asset: name,
      walletAddress,
      walletTag,
      withdrawalAmount,
      chain,
      token: twoFacCode,
    };
    const { status, data } = await withdrawCoins(withdrawInfo);
    if (status === 200) {
      if (data?.message) {
        dispatch(userCoinBalance(name));
        setWithdrawCoinDetails({
          ...withdrawCoinDetails,
          walletAddress: "",
          walletTag: "",
          withdrawalAmount: "",
          chain: "",
          twoFacCode: "",
          openTwoFac: false,
        });
        successMessage(data.message);
      } else if (data.error) {
        errorMessage(data.error);
      } else {
        errorMessage("خطایی رخ داد، لطفا مجددا تلاش کنید");
      }
    } else {
      if (data.status === 404) {
        setWithdrawCoinDetails({
          ...withdrawCoinDetails,
          openTwoFac: false,
        });
        errorMessage("خطایی رخ داد، لطفا مجددا تلاش کنید");
      } else {
        setWithdrawCoinDetails({
          ...withdrawCoinDetails,
          openTwoFac: false,
        });
        errorMessage("خطایی رخ داد، لطفا مجددا تلاش کنید");
      }
    }
  };
  return (
    <div className={styles.container_of_enter2FACode}>
      <form onClick={(e) => handleSubmitWithdraw(e)}>
        <div>
          برای تائید شناسایی دو عاملی خود,کد تولید شده در نرم افزار را ثبت کنید.
        </div>
        <div>
          <input
            type="number"
            placeholder="کد Google Authenticator"
            onChange={(e) =>
              setWithdrawCoinDetails({
                ...withdrawCoinDetails,
                twoFacCode: e.target.value,
              })
            }
            value={withdrawCoinDetails.twoFacCode}
          />
        </div>
        <div>
          کد ۶ رقمی نمایش داده شده در نرم افزار Google Authenticator را ثبت کنید
        </div>
        <div>
          <button>ثبت درخواست</button>
        </div>
      </form>
    </div>
  );
}
///
//ORG
///
export default function ExternalTransfer({ balances, name }) {
  const coinNetwork = useSelector((state) => state.network);
  const dispatch = useDispatch();
  //Open List
  const [openNetworkList, setOpenNetworkList] = useState(true);
  //End Open List
  useEffect(() => {
    dispatch(coinNetworks(name));
  }, []);
  //Important Data
  //STATE FOR HANDLE SUBMIT TRANSFER COIN ----- START ------
  const [withdrawCoinDetails, setWithdrawCoinDetails] = useState({
    currentNetworkOptions: {},
    withdrawalAmount: "",
    walletAddress: "",
    walletTag: "",
    chain: "",
    twoFacCode: "",
    openTwoFac: false,
  });
  //End Important Data
  //EFFECT for handle Component
  useEffect(() => {
    const current = coinNetwork?.data?.filter((f) => f.can_withdraw === true);
    setWithdrawCoinDetails({
      ...withdrawCoinDetails,
      chain: !isEmpty(current) ? current?.shift().chain : "LOCKED",
    });
  }, [coinNetwork]);
  useEffect(() => {
    const currentVal = coinNetwork?.data?.filter(
      (coin) => coin.chain === withdrawCoinDetails.chain
    );
    setWithdrawCoinDetails({
      ...withdrawCoinDetails,
      currentNetworkOptions: { ...currentVal },
    });
  }, [withdrawCoinDetails.chain]);

  // /FUNCTION FOR HANDLE AMOUNT TO TRANSFER
  const [errorEx, setErrorEx] = useState("");
  // Check MAXIMUM VALUE TO WITHDRAW
  const handleChangeWithdrawAmount = (amount, chainFee, useMaxButton) => {
    const maxAmount =
      balances?.asset?.balance - balances?.asset?.locked - chainFee;
    if (maxAmount < 0) {
      setWithdrawCoinDetails({
        ...withdrawCoinDetails,
        withdrawalAmount: 0,
      });
      setErrorEx("موجودی کافی نیست");
    } else if (amount > maxAmount) {
      setWithdrawCoinDetails({
        ...withdrawCoinDetails,
        withdrawalAmount: maxAmount,
      });
      if (!useMaxButton) setErrorEx("موجودی کافی نیست");
    } else {
      setWithdrawCoinDetails({
        ...withdrawCoinDetails,
        withdrawalAmount: amount,
      });
    }
  };
  //END CHECK MAXIMUM

  const handleConfirmDetails = (e) => {
    e.preventDefault();
    if (balances && !balances.gaCode)
      return setErrorEx(
        `برای برداشت ارز نیاز به فعالسازی شناسه دو عاملی می باشد.`
      );
    if (
      withdrawCoinDetails.withdrawalAmount === 0 ||
      withdrawCoinDetails.withdrawalAmount === ""
    )
      return setErrorEx("مبلغ وارد شده نامعتبر است");
    if (
      withdrawCoinDetails.withdrawalAmount <
      +withdrawCoinDetails.currentNetworkOptions[0].withdraw_least_amount
    )
      return setErrorEx("مبلغ وارد شده کمتر از حد مجاز است");
    if (!withdrawCoinDetails.chain)
      return setErrorEx("نوع شبکه را انتخاب کنید");
    if (withdrawCoinDetails.chain === "LOCKED")
      return setErrorEx("امکان انتقال وجود ندارد");
    if (!withdrawCoinDetails.walletAddress)
      return setErrorEx("آدرس کیف پول مقصد را وارد کنید");
    setWithdrawCoinDetails({ ...withdrawCoinDetails, openTwoFac: true });
  };
  const chainAsset =
    name === withdrawCoinDetails.chain
      ? name
      : name + "-" + withdrawCoinDetails.chain;

  if (withdrawCoinDetails.openTwoFac)
    return (
      <Enter2FACode
        setWithdrawCoinDetails={setWithdrawCoinDetails}
        withdrawCoinDetails={withdrawCoinDetails}
        name={name}
      />
    );
  return (
    <>
      <ErrorBox text={errorEx} setText={setErrorEx} />
      <div className={styles.container}>
        <form onSubmit={(e) => handleConfirmDetails(e)}>
          <div className={styles.value_for_withdraw_container}>
            <input
              type="number"
              placeholder="مقدار تراکنش"
              className="changeBackgroundToWhite changeFontColorToBlack"
              pattern="\\d*"
              onChange={(e) =>
                handleChangeWithdrawAmount(
                  e.target.value,
                  withdrawCoinDetails.currentNetworkOptions[0]?.withdraw_tx_fee
                )
              }
              value={withdrawCoinDetails.withdrawalAmount}
            />
            <div
              className={styles.button_of_all_balance}
              onClick={() =>
                handleChangeWithdrawAmount(
                  balances?.asset?.balance - balances?.asset?.locked,
                  withdrawCoinDetails.currentNetworkOptions[0]?.withdraw_tx_fee,
                  true
                )
              }
            >
              کل موجودی
            </div>
          </div>
          <div className={styles.check_network_container}>
            <div className={styles.checkbox_net_place}>
              <label htmlFor="checkbox-transfer-external">
                <input
                  type="checkbox"
                  className={` ${styles.checkbox_input_current} checkbox-in-withdraw-external`}
                  id="checkbox-transfer-external"
                  defaultChecked
                  // onChange={(e) => setOpenNetworkList(e.target.checked)}
                />
                <input
                  type="text"
                  readOnly
                  disabled
                  className={`changeBackgroundToWhite ${styles.value_of_network_input}`}
                  placeholder="نوع شبکه"
                />
                {/* <div className={`${styles.arrow_place_checkbox} `}>
                  <img src={ArrowIcon} alt="" width={15} height={15} />
                </div> */}
              </label>
            </div>
            <div
              className={`changeBackgroundToWhite ${styles.list_of_networks} ${
                openNetworkList ? styles.show_list_of_network : ""
              }`}
            >
              <ul>
                {coinNetwork?.data &&
                  coinNetwork.data?.map((net) => (
                    <li className={styles.list_network} key={net.chain}>
                      <div className={styles.label_network}>
                        <label>
                          <input
                            type="radio"
                            style={{ display: "none" }}
                            name="networkchoice"
                            checked={withdrawCoinDetails.chain === net.chain}
                            className={styles.RadioNetworkCheck}
                            disabled={!net.can_withdraw}
                            onChange={() =>
                              setWithdrawCoinDetails({
                                ...withdrawCoinDetails,
                                chain: net.chain,
                              })
                            }
                          />
                          <div className={styles.check_custom}></div>
                          <span>{net.chain}</span>
                        </label>
                      </div>
                      <div className={styles.amount_of_wage}>
                        <div>{net.withdraw_tx_fee}</div>
                        <div>مقدار کارمزد</div>
                      </div>
                      <div className={styles.line_last}></div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <div className={styles.showNotificationOfNetwork}>
            <div className={styles.iconOfNotificationNetwork}>
              <img src={WaningIcon} alt="" width={20} height={20} />
            </div>
            {withdrawCoinDetails.chain !== "LOCKED" ? (
              <div className={styles.titleNotificationNetwork}>
                توجه: آدرس مقصد باید بر روی شبکه{" "}
                <span>{withdrawCoinDetails?.chain}</span> باشد
              </div>
            ) : (
              <div className={styles.titleNotificationNetwork}>
                موقتا در هیچ یک از شبکه ها امکان انتقال وجود ندارد
              </div>
            )}
          </div>
          <div className={styles.goal_wallet}>
            <input
              className="changeBackgroundToWhite changeFontColorToBlack"
              type="text"
              autoComplete="off"
              placeholder="آدرس کیف پول مقصد"
              onChange={(e) =>
                setWithdrawCoinDetails({
                  ...withdrawCoinDetails,
                  walletAddress: e.target.value,
                })
              }
              value={withdrawCoinDetails.walletAddress}
            />
          </div>
          {withdrawCoinDetails.chain !== "LOCKED" ? (
            <div className={styles.showNotificationForLimit}>
              حداقل مقدار برداشت: {balances?.asset?.symbol}{" "}
              {
                withdrawCoinDetails.currentNetworkOptions[0]
                  ?.withdraw_least_amount
              }{" "}
              و کارمزد انتقال شبکه{" "}
              {withdrawCoinDetails.currentNetworkOptions[0]?.withdraw_tx_fee} می
              باشد
            </div>
          ) : (
            <div className={styles.showNotificationForLimit}>
              موقتا در هیچ یک از شبکه ها امکان انتقال وجود ندارد
            </div>
          )}
          {!isEmpty(coinNetwork) &&
            coinNetwork.withTag.WithdrawWithTagCoins.includes(chainAsset) && (
              <div className={styles.tagInput_container}>
                <input
                  placeholder={coinNetwork.withTag.TagName[chainAsset]}
                  autoComplete="off"
                  onChange={(e) =>
                    setWithdrawCoinDetails({
                      ...withdrawCoinDetails,
                      walletTag: e.target.value,
                    })
                  }
                  value={withdrawCoinDetails.walletTag}
                />
                <div className={styles.titleNotificationNetwork}>
                  دقت کنید در صورتی که کیف مقصد تگ و یا ممو دارد حتما آنرا ثبت
                  کنید
                </div>
              </div>
            )}

          <div
            className={`changeTextColorToGreen ${styles.NotificationForWithdraw}`}
          >
            <p>توجه</p>
            <p>
              1.دقت کنید برداشت ارز فقط در شبکه صحیح انجام شود. ارزفی هیچگونه
              مسيولیتی در قبال از دست رفتن سرمایه شما ندارد. 2.پس از تایید شما
              ارز به شبکه تحویل داده شد و باید منتظر دریافت تاییده در شبکه ماند
            </p>
          </div>
          <button type="submit" className={styles.button_for_submit}>
            ثبت درخواست
          </button>
        </form>
      </div>
    </>
  );
}
